import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 ", "px;\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from "styled-components";
export var colorLibrary = {
  // Palette
  primary: {
    brandRed: "#FF4F51",
    brandYellow: "#FFC34D",
    brandBlue: "#039BE8"
  },
  neutrals: {
    black: "#000000",
    darkGray: "#333333",
    labelGray: "#adadad",
    borderGray: "#d8d8d8",
    lightGray: "#eceded",
    white: "#ffffff"
  },
  blues: {
    coolBlue: "#636b75",
    brandBlue: "#039be8",
    hoverBlue: "#22b3fc",
    backgroundBlue: "#ebf8ff"
  },
  greens: {
    confirmationGreen: "#389e0d",
    hoverGreen: "#4ad011",
    backgroundGreen: "#ecf6e9"
  },
  yellows: {
    brandYellow: "#ffc34d",
    hoverYellow: "#ffd685",
    backgroundYellow: "#fff8eb"
  },
  oranges: {
    warningOrange: "#f68113",
    hoverOrange: "#d46b08",
    backgroundOrange: "#fef4eb"
  },
  reds: {
    dangerRed: "#cf1322",
    hoverRed: "#ea1f30",
    brandRed: "#ff4f51",
    lightHoverRed: "#ff8587",
    backgroundRed: "#fdecee"
  }
};
export var color = {
  // Palette
  primary: colorLibrary.primary.brandBlue,
  secondary: colorLibrary.neutrals.white,
  // ocean
  tertiary: "#DDDDDD",
  orange: "#FC521F",
  gold: "#FFAE00",
  green: "#66BF3C",
  seafoam: "#37D5D3",
  purple: "#6F2CAC",
  ultraviolet: "#2A0481",
  // Monochrome
  lightest: "#FFFFFF",
  lighter: "#F8F8F8",
  light: "#F3F3F3",
  mediumlight: "#EEEEEE",
  medium: "#DDDDDD",
  mediumdark: "#999999",
  dark: "#666666",
  darker: "#444444",
  darkest: "#333333",
  border: "rgba(0,0,0,.1)",
  // Status
  positive: "#66BF3C",
  negative: "#FF4400",
  warning: "#E69D00"
};
export var spacing = {
  padding: {
    small: 10,
    medium: 20,
    large: 30
  },
  borderRadius: {
    small: 5,
    default: 10
  }
};
export var typography = {
  type: {
    primary: '"Lato", "Helvetica Neue", Helvetica, Arial, sans-serif',
    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
  },
  weight: {
    hairline: "100",
    light: "300",
    regular: "normal",
    bold: "bold",
    black: "900"
  },
  size: {
    xl: "30px",
    large: "20px",
    medium: "18px",
    small: "16px",
    xsmall: "14px",
    tiny: "12px"
  }
};
export var buttons = {
  default: {
    fontWeight: typography.weight.black,
    borderRadius: 3,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)"
  },
  primary: {},
  secondary: {
    color: color.primary,
    border: "none",
    "&:hover": {
      color: color.primary,
      border: "1px solid #039BE8"
    }
  }
};
export var breakpoint = 600;
export var pageMargin = "5.55555";
export var pageMargins = css(_templateObject(), spacing.padding.medium, breakpoint * 1, pageMargin * 1, breakpoint * 2, pageMargin * 2, breakpoint * 3, pageMargin * 3, breakpoint * 4, pageMargin * 4);